<template>
  <div class="contents register userInfo">
    <section class="box one">
      <h2>레벨 테스트 문항 {{ editMode ? "수정" : "등록" }}</h2>

      <!-- <Navigation /> -->

      <div class="inputBox listening">
        <div class="flex">
          <p>
            레벨
            <span>*</span>
          </p>
          <el-select v-model="level" placeholder="선택">
            <el-option
              v-for="item in levels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>

        <div class="flex">
          <p>
            문제 타입
            <span>*</span>
          </p>
          <el-select
            v-model="questionType"
            placeholder="선택"
            :disabled="editMode"
          >
            <el-option
              v-for="item in questionTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>

        <div class="flex">
          <p>활성 여부</p>
          <el-switch v-model="active" />
        </div>

        <template v-if="questionType === 'word_sentence'">
          <div class="flex double">
            <p>
              빈칸 앞 문장
              <span>*</span>
            </p>
            <input
              class="full"
              type="text"
              v-model="wordSentenceBefore"
              placeholder="예: 저는 아침마다"
            />
          </div>

          <div class="flex double">
            <p>
              빈칸 뒤 문장
              <span>*</span>
            </p>
            <input
              class="full"
              type="text"
              v-model="wordSentenceAfter"
              placeholder="예: 를 마셔요."
            />
          </div>

          <div class="flex double">
            <p>
              정답
              <span>*</span>
            </p>
            <div class="flex desc listening">
              <div class="arrayRow">
                <input
                  class="full"
                  type="text"
                  v-model="answers[0]"
                  placeholder="빈칸에 들어갈 단어 (보기 중 하나와 동일하게 입력)"
                />
              </div>
            </div>
          </div>

          <div
            class="flex double wordSentencePreview"
            v-if="composedWordSentencePrompt"
          >
            <p>문제 문구 미리보기</p>
            <p class="previewBox">{{ composedWordSentencePrompt }}</p>
          </div>

          <div class="flex double">
            <p>
              보기
              <span>*</span>
            </p>
            <div class="flex desc listening">
              <p class="choiceHint">
                정답을 포함해 서로 다른 보기 3개를 입력해 주세요.
              </p>
              <div class="arrayRow" v-for="index in 3" :key="index - 1">
                <input
                  class="full"
                  type="text"
                  v-model="choices[index - 1]"
                  :placeholder="`보기 ${index}`"
                />
              </div>
            </div>
          </div>

          <div class="flex double">
            <p>번역 · 영어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextEn"
              rows="3"
              placeholder="정답이 포함된 완전한 문장으로 영어 번역 (앱에서 언어 설정이 영어일 때 표시)"
            />
          </div>

          <div class="flex double">
            <p>번역 · 일본어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextJp"
              rows="3"
              placeholder="정답이 포함된 완전한 문장으로 일본어 번역 (앱에서 언어 설정이 일본어일 때 표시)"
            />
          </div>

          <div class="flex double">
            <p>해설 · 영어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationEn"
              rows="3"
              placeholder="영어 UI 사용자용 해설 "
            />
          </div>
          <div class="flex double">
            <p>해설 · 일본어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationJp"
              rows="3"
              placeholder="일본어 UI 사용자용 해설"
            />
          </div>
          <div class="flex double">
            <p>해설 · 한국어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationKo"
              rows="3"
              placeholder="테스트 이력 등에서 사용자에게 보여 줄 한국어 해설"
            />
          </div>
        </template>

        <template v-else-if="questionType === 'short_answer'">
          <div class="flex double">
            <p>
              질문
              <span>*</span>
            </p>
            <textarea
              class="full"
              v-model="promptText"
              placeholder="예: 오늘 기분이 어때요? (질문에 맞는 답을 보기에서 고르게 됩니다)"
            />
          </div>

          <div class="flex double">
            <p>
              정답
              <span>*</span>
            </p>
            <div class="flex desc listening">
              <div class="arrayRow">
                <input
                  class="full"
                  type="text"
                  v-model="answers[0]"
                  placeholder="보기 중 질문에 가장 알맞은 답 한 줄 (보기와 동일하게 입력)"
                />
              </div>
            </div>
          </div>

          <div class="flex double">
            <p>
              보기
              <span>*</span>
            </p>
            <div class="flex desc listening">
              <p class="choiceHint">
                질문에 어울리는 답·그렇지 않은 답 등 서로 다른 보기 3개 (정답
                포함)
              </p>
              <div class="arrayRow" v-for="index in 3" :key="index - 1">
                <input
                  class="full"
                  type="text"
                  v-model="choices[index - 1]"
                  :placeholder="`보기 ${index}`"
                />
              </div>
            </div>
          </div>

          <div class="flex double">
            <p>번역 · 영어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextEn"
              rows="3"
              placeholder="예: How do you feel today? (앱에서 질문 아래 보조 문구로 표시)"
            />
          </div>

          <div class="flex double">
            <p>번역 · 일본어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextJp"
              rows="3"
              placeholder="질문 일본어 번역 (앱에서 질문 아래 보조 문구로 표시)"
            />
          </div>

          <div class="flex double">
            <p>해설 · 영어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationEn"
              rows="3"
              placeholder="영어 UI 사용자용 해설 "
            />
          </div>
          <div class="flex double">
            <p>해설 · 일본어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationJp"
              rows="3"
              placeholder="일본어 UI 사용자용 해설"
            />
          </div>
          <div class="flex double">
            <p>해설 · 한국어 (선택)</p>
            <textarea
              class="full"
              v-model="explanationKo"
              rows="3"
              placeholder="테스트 이력 등에서 사용자에게 보여 줄 한국어 해설"
            />
          </div>
        </template>

        <template v-else-if="questionType === 'speaking_listen'">
          <div class="flex double">
            <p>
              질문
              <span>*</span>
            </p>
            <textarea
              class="full"
              v-model="promptText"
              placeholder="앱에서 TTS로 읽을 한국어 질문 (예: 오늘 기분이 어때요?)"
            />
          </div>

          <div class="flex double">
            <p>번역 · 영어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextEn"
              rows="3"
              placeholder="예: How do you feel today? (질문 아래 보조 문구로 표시)"
            />
          </div>

          <div class="flex double">
            <p>번역 · 일본어 (선택)</p>
            <textarea
              class="full"
              v-model="promptTextJp"
              rows="3"
              placeholder="질문 일본어 번역 (질문 아래 보조 문구로 표시)"
            />
          </div>

          <div class="flex double">
            <p>해설</p>
            <p class="choiceHint speakingListenHint">
              말하기/듣기 유형은 답변마다 해설이 달라질 수 있어, 문항에는
              저장하지 않습니다. 세션 검토 화면에서 답변별로 입력할 예정입니다.
            </p>
          </div>
        </template>

        <div class="flex double" v-else>
          <p>
            문제 문구
            <span>*</span>
          </p>
          <textarea
            class="full"
            v-model="promptText"
            placeholder="질문 또는 문항 본문"
          />
        </div>
      </div>

      <div class="buttonWrap">
        <button class="basic" @click="submit">
          {{ editMode ? "수정" : "등록" }}
        </button>
        <button v-if="editMode" class="line" @click="handleDelete">삭제</button>
      </div>
    </section>

    <div class="buttonWrap">
      <router-link :to="backLink">
        <span class="material-icons-round"> keyboard_backspace </span>목록
      </router-link>
    </div>
  </div>
</template>

<script>
import {
  createLevelTestProblem,
  fetchLevelTestProblem,
  removeLevelTestProblem,
  updateLevelTestProblem,
} from "@/api/admin";
import {
  LEVEL_TEST_LEVELS,
  LEVEL_TEST_QUESTION_TYPES,
} from "@/config/levelTest";
// import Navigation from "../Navigation.vue";

export default {
  name: "levelTestProblemRegister",
  // components: {
  //   Navigation,
  // },
  data() {
    return {
      editMode: false,
      problemId: "",
      level: "",
      questionType: "",
      active: true,
      promptText: "",
      wordSentenceBefore: "",
      wordSentenceAfter: "",
      promptTextEn: "",
      promptTextJp: "",
      responseMode: "choice",
      choices: ["", "", ""],
      answers: [""],
      explanationKo: "",
      explanationEn: "",
      explanationJp: "",
      levels: LEVEL_TEST_LEVELS,
      questionTypes: LEVEL_TEST_QUESTION_TYPES,
    };
  },
  computed: {
    composedWordSentencePrompt() {
      return this.composeWordSentencePrompt();
    },
    backLink() {
      const query = {};
      ["page", "searchWord", "level", "questionType", "active"].forEach(
        (key) => {
          if (this.$route.query[key]) {
            query[key] = this.$route.query[key];
          }
        },
      );
      return Object.keys(query).length
        ? { name: "levelTestProblemManage", query }
        : { name: "levelTestProblemManage" };
    },
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "6");
  },
  mounted() {
    this.level = this.$route.query.level || "";
    this.questionType = this.$route.query.questionType || "";
    this.syncChoiceSlotsForQuestionType();
    if (this.$route.query.id) {
      this.editMode = true;
      this.problemId = this.$route.query.id;
      this.getProblem();
    }
  },
  watch: {
    questionType(value, oldVal) {
      if (value === "word_sentence" || value === "short_answer") {
        this.responseMode = "choice";
        if (this.answers.length > 1) {
          this.answers = [this.answers[0] || ""];
        }
      }
      if (value === "word_sentence") {
        if (oldVal && oldVal !== "word_sentence") {
          const parsed = this.parseWordSentencePrompt(this.promptText);
          this.wordSentenceBefore = parsed.before;
          this.wordSentenceAfter = parsed.after;
        }
      }
      if (oldVal === "word_sentence" && value !== "word_sentence") {
        this.promptText = this.composeWordSentencePrompt() || this.promptText;
        this.wordSentenceBefore = "";
        this.wordSentenceAfter = "";
        this.promptTextEn = "";
        this.promptTextJp = "";
      }
      if (oldVal === "short_answer" && value !== "short_answer") {
        this.promptTextEn = "";
        this.promptTextJp = "";
      }

      if (value === "speaking_listen") {
        this.explanationKo = "";
        this.explanationEn = "";
        this.explanationJp = "";
      }
      this.syncChoiceSlotsForQuestionType();
    },
  },
  methods: {
    syncChoiceSlotsForQuestionType() {
      if (
        this.questionType === "word_sentence" ||
        this.questionType === "short_answer"
      ) {
        const c = Array.isArray(this.choices) ? [...this.choices] : [];
        while (c.length < 3) {
          c.push("");
        }
        this.choices = c.slice(0, 3);
      } else {
        this.choices = [""];
      }
    },
    parseWordSentencePrompt(text) {
      const raw = String(text || "");
      const m = raw.match(/^([\s\S]*?)\[\s*\]([\s\S]*)$/);
      if (!m) {
        return { before: raw.trim(), after: "" };
      }
      return { before: m[1], after: m[2] };
    },
    composeWordSentencePrompt() {
      const before = this.wordSentenceBefore ?? "";
      const after = this.wordSentenceAfter ?? "";
      if (!String(before).trim() && !String(after).trim()) {
        return "";
      }
      // 앞: `[` 전에만 필요 시 한 칸(입력 끝 공백과 중복 안 함). 뒤: 공백은 전부 뒷문장 입력에 맡김.
      const sepBefore = before.length && !/\s$/.test(before) ? " " : "";
      return `${before}${sepBefore}[ ]${after}`;
    },
    normalizeArray(items) {
      const values = items.map((item) => (item || "").trim()).filter(Boolean);
      return [...new Set(values)];
    },
    applyProblem(item) {
      this.level = item.level || "";
      this.questionType = item.questionType || "";
      this.active = item.active !== false;
      this.promptText = item.promptText || "";
      if (item.questionType === "word_sentence") {
        const hasSeparateWordParts =
          item.wordSentenceBefore !== undefined ||
          item.wordSentenceAfter !== undefined;
        if (hasSeparateWordParts) {
          this.wordSentenceBefore = String(item.wordSentenceBefore ?? "");
          this.wordSentenceAfter = String(item.wordSentenceAfter ?? "");
        } else {
          const parsed = this.parseWordSentencePrompt(item.promptText || "");
          this.wordSentenceBefore = parsed.before;
          this.wordSentenceAfter = parsed.after;
        }
        this.promptTextEn = item.promptTextEn || "";
        this.promptTextJp = item.promptTextJp || "";
        const ch = (item.choices || []).map((x) => String(x ?? ""));
        while (ch.length < 3) {
          ch.push("");
        }
        this.choices = ch.slice(0, 3);
      } else if (item.questionType === "short_answer") {
        this.wordSentenceBefore = "";
        this.wordSentenceAfter = "";
        this.promptTextEn = item.promptTextEn || "";
        this.promptTextJp = item.promptTextJp || "";
        const ch = (item.choices || []).map((x) => String(x ?? ""));
        while (ch.length < 3) {
          ch.push("");
        }
        this.choices = ch.slice(0, 3);
      } else if (item.questionType === "speaking_listen") {
        this.wordSentenceBefore = "";
        this.wordSentenceAfter = "";
        this.promptTextEn = item.promptTextEn || "";
        this.promptTextJp = item.promptTextJp || "";
        this.choices = [""];
      } else {
        this.wordSentenceBefore = "";
        this.wordSentenceAfter = "";
        this.promptTextEn = "";
        this.promptTextJp = "";
        this.choices = [""];
      }
      this.responseMode =
        item.questionType === "word_sentence" ||
        item.questionType === "short_answer"
          ? "choice"
          : item.responseMode || "choice";
      if (
        item.questionType === "word_sentence" ||
        item.questionType === "short_answer"
      ) {
        this.explanationKo = item.explanationKo || item.explanation || "";
        this.explanationEn = item.explanationEn || "";
        this.explanationJp = item.explanationJp || "";
      } else {
        this.explanationKo = "";
        this.explanationEn = "";
        this.explanationJp = "";
      }

      if (this.questionType === "speaking_listen") {
        this.answers = [];
      } else {
        this.answers = this.normalizeArray(item.answers || []);
        if (this.answers.length === 0) {
          this.answers = [""];
        }
        if (
          (this.questionType === "word_sentence" ||
            this.questionType === "short_answer") &&
          this.answers.length > 1
        ) {
          this.answers = [this.answers[0] || ""];
        }
      }
    },
    getProblem() {
      fetchLevelTestProblem(this.problemId).then((res) => {
        if (res.data.status === 200) {
          this.applyProblem(res.data.data || {});
        } else {
          alert(res.data.message || "문항 정보를 불러오지 못했습니다.");
        }
      });
    },
    buildPayload() {
      const responseMode =
        this.questionType === "word_sentence" ||
        this.questionType === "short_answer"
          ? "choice"
          : this.responseMode;
      return {
        level: this.level,
        questionType: this.questionType,
        active: this.active,
        promptText:
          this.questionType === "word_sentence"
            ? this.composeWordSentencePrompt()
            : this.promptText.trim(),
        wordSentenceBefore:
          this.questionType === "word_sentence" ? this.wordSentenceBefore : "",
        wordSentenceAfter:
          this.questionType === "word_sentence" ? this.wordSentenceAfter : "",
        responseMode,
        choices:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer"
            ? [0, 1, 2].map((i) => String(this.choices[i] || "").trim())
            : [],
        answers:
          this.questionType === "speaking_listen"
            ? []
            : this.normalizeArray(this.answers),
        explanationKo:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer"
            ? this.explanationKo.trim()
            : "",
        explanationEn:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer"
            ? this.explanationEn.trim()
            : "",
        explanationJp:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer"
            ? this.explanationJp.trim()
            : "",
        explanation:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer"
            ? this.explanationKo.trim()
            : "",
        promptTextEn:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer" ||
          this.questionType === "speaking_listen"
            ? this.promptTextEn.trim()
            : "",
        promptTextJp:
          this.questionType === "word_sentence" ||
          this.questionType === "short_answer" ||
          this.questionType === "speaking_listen"
            ? this.promptTextJp.trim()
            : "",
      };
    },
    validatePayload(payload) {
      if (!payload.level) {
        return "레벨을 선택해 주세요.";
      }
      if (!payload.questionType) {
        return "문제 타입을 선택해 주세요.";
      }
      if (!payload.promptText) {
        if (
          payload.questionType === "speaking_listen" ||
          payload.questionType === "short_answer"
        ) {
          return "질문을 입력해 주세요.";
        }
        return "문제 문구를 입력해 주세요.";
      }
      if (
        payload.questionType !== "speaking_listen" &&
        payload.answers.length === 0
      ) {
        return "정답을 하나 이상 입력해 주세요.";
      }
      if (payload.questionType === "word_sentence") {
        const ch = payload.choices;
        if (ch.length !== 3 || ch.some((c) => !c)) {
          return "보기는 정답 포함 서로 다른 3개를 모두 입력해 주세요.";
        }
        if (new Set(ch).size !== 3) {
          return "보기 3개는 서로 중복될 수 없습니다.";
        }
        if (!this.wordSentenceBefore.trim() || !this.wordSentenceAfter.trim()) {
          return "단어/문장 유형은 빈칸 앞·뒤 문장을 모두 입력해 주세요.";
        }
        if (payload.answers.length !== 1) {
          return "문장/단어 유형은 정답을 하나만 입력해 주세요.";
        }
        const answer = payload.answers[0];
        if (!payload.choices.includes(answer)) {
          return "정답은 보기 중 하나와 동일한 문자열이어야 합니다.";
        }
      }
      if (payload.questionType === "short_answer") {
        const ch = payload.choices;
        if (ch.length !== 3 || ch.some((c) => !c)) {
          return "단답형은 보기 3개를 모두 입력해 주세요.";
        }
        if (new Set(ch).size !== 3) {
          return "단답형 보기 3개는 서로 중복될 수 없습니다.";
        }
        if (payload.answers.length !== 1) {
          return "단답형은 정답을 하나만 입력해 주세요.";
        }
        const answer = payload.answers[0];
        if (!payload.choices.includes(answer)) {
          return "정답은 보기 중 하나와 동일한 문자열이어야 합니다.";
        }
      }
      return "";
    },
    submit() {
      const payload = this.buildPayload();
      const error = this.validatePayload(payload);
      if (error) {
        return alert(error);
      }

      const request = this.editMode
        ? updateLevelTestProblem(this.problemId, payload)
        : createLevelTestProblem(payload);

      request.then((res) => {
        if (res.data.status === 200) {
          alert(
            `레벨 테스트 문항 ${
              this.editMode ? "수정" : "등록"
            }이 완료 되었습니다.`,
          );
          this.$router.push(this.backLink);
        } else {
          alert(res.data.message || "저장에 실패했습니다.");
        }
      });
    },
    handleDelete() {
      if (!confirm("삭제 하시겠습니까?")) {
        return;
      }
      removeLevelTestProblem(this.problemId).then((res) => {
        if (res.data.status === 200) {
          alert("문항이 삭제 되었습니다.");
          this.$router.push(this.backLink);
        } else {
          alert(res.data.message || "삭제에 실패했습니다.");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.levelTestNav {
  margin: 20px 0 30px 0;
}
textarea {
  width: 100% !important;
  min-height: 100px;
}

.arrayRow {
  display: flex;
  width: 100%;
  gap: 8px;
}

.arrayRow + .arrayRow {
  margin-top: 8px;
}

.addButton,
.removeButton {
  min-width: 92px;
}

.addButton {
  margin-top: 8px;
}

.wordSentencePreview .previewBox {
  margin: 0;
  padding: 12px 14px;
  width: 100%;
  border-radius: 8px;
  background: #f5f5f5;
  font-size: 15px;
  line-height: 1.5;
}

.choiceHint {
  width: 100% !important;
  margin: 0 0 8px 0 !important;
  font-size: 13px !important;
  color: #666 !important;
}

.flex.double .speakingListenHint {
  width: calc(100% - 285px);
  max-width: unset;
  margin-bottom: 0 !important;
}
</style>
